import type { RouteMeta, RouteRecordRaw } from 'vue-router';

export function sortRoutes(r1: RouteRecordRaw, r2: RouteRecordRaw) {
    if (r1.meta && r2.meta) {
        if (r1.meta.menuOrder && r2.meta.menuOrder) return r1.meta.menuOrder - r2.meta.menuOrder;

        return r1.meta.title.localeCompare(r2.meta.title);
    }

    return 0;
}
